import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import ShowToast from "../../../widget/common/ui/Toast";
import {
  MenuStatusList,
  MenuStatusListModel,
} from "../../../model/work_profile/MenuStatusListModel";

const WorkProfileProvider = new (class WorkProfileProvider {
  getWorkMenuAPI = async (): Promise<MenuStatusList | null> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    const url: string = `${ApiUrls.baseUrl}settings/menu/get_menu_status_list`;
    //String adminStatus =  await CachedStorage().getValue(key: "admin_status") ?? "0";
    const adminStatus: string = "0";

    const body: any = {
      account_id: accountId,
      admin_status: adminStatus,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const menuStatusListModel: MenuStatusListModel = response;
        const menuStatusList: MenuStatusList =
          menuStatusListModel?.result?.menu_status_list!;

        return menuStatusList;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default WorkProfileProvider;
